import React, { useState } from "react";
import EditEmployementInformationModal from "../EditEmployementInformationModal/EditEmployementInformationModal";
import { useGetEmployeeEmploymentDates } from "../../../queries/employeeQueries";
import { useSelector } from "react-redux";
import userRoleAuth from "../../../utils/userRoleAuth/userRoleAuth";
import userRoles from "../../../config/userRoles";
import moment from "moment";
const JobEmployementInfo = ({ employee }) => {
  const [openModal, setOpenModel] = useState(false);
  const onOpenModal = () => setOpenModel(true);
  const onCloseModal = () => setOpenModel(false);
  const loggedInUser = useSelector((state) => state.user.auth);
  const isHr = userRoleAuth(loggedInUser, userRoles.HR);
  const isAdmin = userRoleAuth(loggedInUser, userRoles.TENANTADMIN);
  const isAdminOrHR = isHr || isAdmin;
  const { data, isLoading } = useGetEmployeeEmploymentDates({
    employee_id: employee?.employee_id,
  });

  const formatDate = (date, loadingMsg, noDataMsg) => {
    if (isLoading) return loadingMsg;
    if (date && moment(date).isValid())
      return moment(date).format("DD MMMM YYYY");
    return noDataMsg;
  };

  const employeeJoiningDate = data?.data?.[0]?.joining_date; 
const employeeEndDate = data?.data?.[0]?.ending_date;
  const joining_date = formatDate(
    employeeJoiningDate,
    "Loading...",
    "No joining date available"
  );
  const ending_date = formatDate(
    employeeEndDate,
    "Loading...",
    "No ending date available"
  );

  return (
    <div className="bg-white px-8 py-6 rounded-md border border-gray-100 shadow-md shadow-[#F3F4F6] mt-6 mb-5">
      <div className="flex items-center justify-between pb-3">
        <div className="flex items-center gap-3">
          <img src="/images/basic-info-icon.svg" alt="" />
          <p className="text-base text-[#1F2937] font-semibold">
            Employment Information
          </p>
        </div>
        {isAdminOrHR && (
          <div className="cursor-pointer">
            <img
              src="/images/editicon.svg"
              alt=""
              onClick={() => onOpenModal()}
            />
            {openModal && (
              <EditEmployementInformationModal
                openModal={openModal}
                onCloseModal={onCloseModal}
                employee={employee}
                employeeJoiningDate={employeeJoiningDate}
                employeeEndDate={employeeEndDate}
              />
            )}
          </div>
        )}
      </div>
      <div className="flex justify-between employee-info-card">
        <table className="border-0">
          <tbody>
            <tr>
              <td className="title">Join Date </td>
              <td className="data">{joining_date} </td>
            </tr>
            <tr>
              <td className="title">End Date </td>
              <td className="data">{ending_date} </td>
            </tr>

            {/* Will Be used in later updates */}
            {/* <td className="title">Probation Start Date </td>
              <td className="data">- </td>
            </tr>
            <tr>
              <td className="title">Contract Name </td>
              <td className="data">Jhon Cameron</td>
              <td className="title">Probation End Date</td>
              <td className="data">-</td>
            </tr>
            <tr>
              <td className="title">Contract Start Date</td>
              <td className="data">Jhon Cameron </td>
            </tr>
            <tr>
               */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default JobEmployementInfo;
